import { CheckBoxWidget } from '@tableau/widgets';
import { DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';
import { elideTextStyle } from '../style/LayoutStyles';
import { cssClass } from '../style/StyleFunctions';
import { SelectionColumnKey, TypedBodyCellProps, UnsortableColumn } from './TypedDataGridInterfaces';
import { cellPaddingStyle } from './cellFormatters/CellStyles';

export const SPACE_BAR = ' ';

const selectionContainerClass = cssClass('selectionContainer', elideTextStyle, cellPaddingStyle, {
  height: '100%'
});

export function createSelectionColumn<T>(): UnsortableColumn<T> {
  return {
    name: SelectionColumnKey,
    dataKey: SelectionColumnKey,
    headerText: '',
    // eslint-disable-next-line react/display-name
    cellFormatter: (props: TypedBodyCellProps<T>) => (
      <div className={selectionContainerClass}>
        <CheckBoxWidget checked={props.isSelected} testId={`checkbox-cell-${props.row.key}`} />
      </div>
    ),
    resizable: false,
    sortable: false,
  };
}

export function isSelectionColumnEvent(event: DataGrid.CellSelectionEvent): boolean {
  const isSelectionColumn = event.cell.colKey === SelectionColumnKey;
  const fromMouseClick = event.type === 'mousedown';
  const fromSpaceBarPress = event.type === 'keydown' && event.key === SPACE_BAR;
  return isSelectionColumn && (fromMouseClick || fromSpaceBarPress);
}

export function isSelectionRowEvent(event: DataGrid.CellSelectionEvent): boolean {
  const isSelection = !!event.cell.rowKey;
  // TFSID 928989
  // Disabling space bar press selection given keyboard navigation is not working
  return isSelection && (event.type === 'mousedown' || event.type === 'touchstart');
}
